import { Component } from '@angular/core'

@Component({
	selector: 'accommodation',
	templateUrl: './Accommodation.Component.html',
})
export class AccommodationComponent {}
